import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import popin_svg from '../../../assets/img/SVG_icons/Top/advanced_operation/popin.svg';
import { img } from '@phi/components';
import { uid_popin_one_or_many } from '@features/popin-popout';
import PopinTooltip from './PopinTooltip';
import { ISubscriptions } from '@phi/subscriptions/frontend';

export const PopinIcon = popin_svg;

export default defineComponent({
    props: {
        state: { required: true, type: Object as PropType<State> },
        subscriptions: { required: true, type: Object as PropType<ISubscriptions> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Popin';
        },

        disabled() {
            return this.state.editing_reference_sketches
                || this.state.selected_faces_count === 0;
        },
    },

    watch: {
        disabled(value: boolean) {
            this.$emit('update:disabled', value);
        },
    },

    emits: {
        'update:disabled': (x: boolean) => true,
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else
                uid_popin_one_or_many();
        },
    },

    render() {
        return h(BarButton, {
            disabled: this.disabled,
            selected: this.state.tut_stage === 4,
            active: false,
            id: 'popin-button',
            tippy: 'left',
            onClick: this.onClick,
            help: 'popin',
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(popin_svg, this.alt),
            tooltip: PopinTooltip,
        });
    },
});
